import React from 'react'
import { removeItemfromArray } from '../../../functions/lists'


const MultiselectCheckboxAttributes = ({field, form, ...props}) => {
    const { type, attrid, movieid, value } = props
    
    return (
        <label>
            <input
                {...props}
                {...field}
                type="checkbox"
                checked={value.movies.includes(movieid)}
                onChange={() => {
                    let removeAttribute = null

                    if(value.movies.includes(movieid)) {
                        value.movies = removeItemfromArray(value.movies, movieid)
                        removeAttribute = true
                    } else {
                        value.movies.push(movieid)
                        removeAttribute = false
                    }

                    form.setFieldValue(field.name, value)

                    if(true === removeAttribute) {
                        if("attributes" === type) {
                            const index = form.values.movie.technologyAttributes.findIndex(item => item.id === attrid)

                            if(-1 !== index) {
                                form.values.movie.technologyAttributes.splice(index, 1)

                                form.setFieldValue('movie.technologyAttributes', form.values.movie.technologyAttributes)
                            }
                        } else if("genres" === type) {
                            form.setFieldValue('movie.genres', removeItemfromArray(form.values.movie.genres, value.name))
                        }
                    }

                    if(false === removeAttribute) {
                        if("attributes" === type) {
                            form.values.movie.technologyAttributes.push({
                                id: attrid,
                                name: value.name
                            })

                            form.setFieldValue('movie.technologyAttributes', form.values.movie.technologyAttributes)
                        } else if("genres" === type) {
                            form.values.movie.genres.push(value.name)
                            form.setFieldValue('movie.genres', form.values.movie.genres)
                        }
                    }
                }}
            />
            <span className="text-small-regular">{props.value.name}</span>
        </label>
    )
}



export default MultiselectCheckboxAttributes